import { MenuItem } from '@mui/material';
import { useState } from 'react';
import { ProvisionCsAccountModal } from './ProvisionCsAccountModal';

interface Props {
  accountId: number;
}

export const ProvisionCsAccount = ({ accountId }: Props) => {
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  return (
    <>
      <MenuItem
        onClick={() => {
          setModalOpen(true);
        }}
      >
        Provision new CS project
      </MenuItem>

      {isModalOpen && (
        <ProvisionCsAccountModal
          accountId={accountId}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
};
